export default [{
    path: '/pedagogic/appointment/:id',
    name: 'pedagogic-appointment',
    component: () => import('@/views/apps/pedagogic/appointment/index.vue'),
  }]